import { Reducer, configureStore } from "@reduxjs/toolkit";
import conversationReducer, { ConversationState } from "./conversationSlice";
import appReducer, { AppState } from "./appSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { scenarioApi } from "../services/scenarios";
import { safeguardApi } from "../services/safeguard";

const persistConfig = {
  key: "root",
  storage,
};

export const store = configureStore({
  reducer: {
    conversation: persistReducer(
      persistConfig,
      conversationReducer
    ) as unknown as Reducer<ConversationState>,
    app: persistReducer(
      persistConfig,
      appReducer
    ) as unknown as Reducer<AppState>,
    [scenarioApi.reducerPath]: scenarioApi.reducer,
    [safeguardApi.reducerPath]: safeguardApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(scenarioApi.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
